<template>
  <div class="HelpSidePanel">
    <transition name="slide-fade">
      <b-card class="help-sidepanel" v-show="help">
        <div slot="header">
          <button class="btn  btn-outline-primary"
                  :class="{'btn-primary':help}"
                  @click="help=!help">{{ $t("HelpSidePanel.close") }}
              <i class="fa fa-close"></i></button>
        </div>
        <slot></slot>
      </b-card>
    </transition>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        HelpSidePanel: {
          close: 'close'
        }
      },
      es: {
        HelpSidePanel: {
          close: 'cerrar'
        }
      }
    }
  },
  name: 'HelpSidePanel',
  data: function () {
    return {
      help: false
    };
  },
  methods: {
    toggle () {
      return (this.help = !this.help);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/HelpSidePanel.vue